<template>
    <div class="sidebar-light">
        <ul class="nav nav-sidebar">
            <li class="nav-item-header">
                {{ credentialType.name }}
            </li>
            <li class="nav-item" v-for="credential in credentials" :key="credential.uuid">
                <a class="nav-link cursor-pointer d-flex align-items-center"
                   :class="{active: credential.uuid === selectedUuid}"
                   @click.prevent="setCredential(credential)"
                >
                    <fa-icon icon="cogs" class="mr-3" />
                    {{ credential.name || $t('credentials.not_set') }}
                    <fa-icon
                            :icon="credential.active ? 'toggle-on':'toggle-off'"
                            :class="credential.active ? 'text-success' : 'text-danger'"
                            class="ml-auto"></fa-icon>
                </a>
            </li>
            <li class="nav-item">
                <a href class="nav-link cursor-pointer" @click.prevent="addCredential()">
                    <i class="icon-plus2" />  {{$t('credentials.add_new_credential_button')}}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>

    import {EDIT_CREDENTIAL} from "../store/types";
    import store from "../store/store";

    export default {
        name: "CredentialSelect",
        computed: {
            ...store.mapGetters(['credentialType', 'credentials']),
            ...store.mapState({selected: 'credential'}),
            selectedUuid() {
                return (this.selected || {uuid: null}).uuid;
            }
        },
        methods: {
            setCredential: (credential) => store.dispatch(EDIT_CREDENTIAL, credential),
            addCredential: () => store.dispatch(EDIT_CREDENTIAL)
        }
    }
</script>
